export const FS_ENV_ID = 'fsEnvId';

export const DISABLED_COOKIES = 'Disabled cookies';

export const SENTRY_TAG_ERROR_BOUNDARY = 'ErrorBoundary' as const;
